<template>
    <label :for="id" class="flex items-center select-none">
        <input :id="id" hidden type="checkbox" :name="name" :value="value" v-bind:checked="selected" @change="change(value)">
        <span
            class="block rounded-full border border-next-dark-gray mr-2 cursor-pointer shrink-0"
            :class="[selected ? 'border-next-orange bg-next-orange':'', checkClass ]"></span>
        <span class="text-left whitespace-pre-wrap"><slot></slot></span>
    </label>
</template>

<script lang="ts">
import {Options, Vue, setup} from 'vue-class-component';
import Modal from "@/components/Modal.vue";
import NextButton from "@/components/NextButton.vue";
import {mapActions, mapGetters, mapState} from 'vuex';
@Options({
    name:'Radio',
    components: {
        NextButton,
    },
    inheritAttrs:false,
    props: {
        id: [String, Number],
        checkClass: String,
        modelValue: [String, Number],
        value:  [String, Number],
        name: String,
    },
})
export default class Radio extends Vue {
    value!:number
    modelValue!:any

    get selected(){
        return this.value === this.modelValue
    }

    change(val:any){
        this.$emit('update:modelValue', val)
    }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
